import { render, staticRenderFns } from "./exerciseRow.vue?vue&type=template&id=16550ffd&"
import script from "./exerciseRow.vue?vue&type=script&lang=js&"
export * from "./exerciseRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports